module.exports = __webpack_public_path__ + "static/UploadRoot-df748daf6159f760c7e367e03dd6aa74.png";